module.exports = __webpack_public_path__ + "static/media/m_b_55.0fcd4c22.png";